function ContactIntro() {
  const url = new URLSearchParams(window.location.href);
  const submitState = url.get('submit');
  const introText = submitState === 'success'
    ? 'Message envoyé avec succès !'
    : submitState === 'failed'
      ? 'Une erreur est survenue !'
      : 'Un projet ? Une interrogation ? Contactez nous !';

  return (
    <div className="text-center mt-20 text-4xl font-bold m6:text-3xl px-10" id="contact">
      <span id='contact-intro-text'>{introText}</span>
    </div>
  );
}

export default ContactIntro;